module.exports = __webpack_public_path__ + "static/img/far2.a1e7b201.png";